module.exports = "pegasus/assets/custom-1-facebook.png";